import { Pipe, PipeTransform } from '@angular/core';
import { Delivery } from '../entities/delivery';

@Pipe({
    name: 'filterDelivery',
    pure: false
})
export class FilterDeliveryPipe implements PipeTransform {
    transform(deliveries: Delivery[], filterQuery: string): any {
        if (!deliveries || !filterQuery) {
            return deliveries;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return deliveries.filter(delivery => 
                delivery.idCustom.indexOf(filterQuery) > -1 ||
                (delivery.vehicle && delivery.vehicle.name && delivery.vehicle.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
                (delivery.driver && delivery.driver.name && delivery.driver.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
                (delivery.deliveryGroup && delivery.deliveryGroup.name && delivery.deliveryGroup.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1));
        //return items.filter(item => item.title.indexOf(filter.title) !== -1);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/pipes/filter-delivery-directive.ts